// Amplify v6 configuration shape
const amplifyConfigure = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_LOGIN_URL,
          scopes: [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "profile",
          ],
          redirectSignIn: [`${window.location.origin}/callback`],
          redirectSignOut: [`${window.location.origin}/`],
          responseType: "code",
        },
      },
    },
  },
};

export default amplifyConfigure;
